<form [formGroup]="form" novalidate>
  <div class="form-group mr-3">
    <label for="year">Year</label>
    <div ngbDropdown>
      <button ngbDropdownToggle class="btn btn-alternate dropdown-toggle" type="button" id="yearEntryMenu">
        {{ selectedYear || 'Select' }}
      </button>
      <div ngbDropdownMenu aria-labelledby="yearEntryMenu">
        <a *ngFor="let year of years" href="#" class="dropdown-item" (click)="selectYear(year, $event)">{{ year }}</a>
      </div>
    </div>
  </div>
  <div class="form-group mr-3">
    <label for="month" [class.disabled]="!selectedYear">Month (optional)</label>
    <div ngbDropdown>
      <button
        ngbDropdownToggle
        class="btn btn-alternate dropdown-toggle"
        type="button"
        id="monthEntryMenu"
        [disabled]="!selectedYear"
      >
        {{ selectedMonth?.name || 'Select' }}
      </button>
      <div ngbDropdownMenu aria-labelledby="monthEntryMenu">
        <a *ngFor="let month of months" href="#" class="dropdown-item" (click)="selectMonth(month, $event)">{{
          month.name
        }}</a>
      </div>
    </div>
  </div>
</form>
